/* ZUNESIA — scripts propios (sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.zn-reveal:not(.zn-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('zn-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('zn-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Seguro: si algún navegador no avisa al hacer scroll, mostramos lo que ya está en pantalla
    function fallback() {
      document.querySelectorAll('.zn-reveal:not(.zn-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('zn-visible');
      });
    }
    if (!window.__znRevealFallback) {
      window.__znRevealFallback = true;
      window.addEventListener('scroll', fallback, { passive: true });
      window.addEventListener('load', fallback);
    }
    setTimeout(fallback, 1500);
  }

  function initCifras(scope) {
    var nums = (scope || document).querySelectorAll('[data-zn-count]:not([data-done])');
    if (!nums.length) return;
    function run(el) {
      el.setAttribute('data-done', '1');
      var target = parseFloat(el.getAttribute('data-zn-count')) || 0;
      var dur = 1500, t0 = null;
      if (reduce) { el.textContent = target; return; }
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      }
      el.textContent = '0';
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-zn-parallax]');
    if (!els.length || reduce || window.innerWidth < 990) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-zn-parallax')) || 0;
        if (!k) return;
        var r = el.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * k / 100;
        el.style.transform = 'translate3d(0,' + (-off).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    if (fmt && fmt.indexOf('{{') > -1) return fmt.replace(/\{\{\s*\w+\s*\}\}/, withSep);
    return withSep + ' €';
  }

  function initCompra(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    // Galería
    var main = root.querySelector('[data-zn-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-zn-thumb]'));
    var current = Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }));
    function show(i) {
      if (!main || !thumbs.length) return;
      current = (i + thumbs.length) % thumbs.length;
      var t = thumbs[current];
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      main.style.opacity = 0;
      setTimeout(function () {
        main.src = t.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.alt = t.getAttribute('data-alt') || '';
        main.style.opacity = 1;
      }, 140);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    root.querySelectorAll('[data-zn-nav]').forEach(function (b) {
      b.addEventListener('click', function () { show(current + parseInt(b.getAttribute('data-zn-nav'), 10)); });
    });
    // Deslizar con el dedo en móvil
    if (main) {
      var x0 = null;
      main.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.parentElement.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    // Variantes
    var dataEl = root.querySelector('[data-zn-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var fmt = root.getAttribute('data-money-format');
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceNow = root.querySelectorAll('[data-zn-price]');
    var priceOld = root.querySelectorAll('[data-zn-compare]');
    var saveEl = root.querySelector('[data-zn-save]');
    var btn = root.querySelector('[data-zn-add]');
    var btnLabel = root.querySelector('[data-zn-add-label]');
    var txtAdd = btn ? btn.getAttribute('data-txt-add') : '';
    var txtSold = btn ? btn.getAttribute('data-txt-sold') : '';
    var txtNone = btn ? btn.getAttribute('data-txt-none') : '';
    var fsets = Array.prototype.slice.call(root.querySelectorAll('[data-zn-option]'));

    function selected() {
      return fsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function update(e) {
      if (!variants.length) return;
      var vals = selected();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === vals[i]; });
      });
      if (!v && e && e.target) {
        var idx = fsets.indexOf(e.target.closest('[data-zn-option]'));
        var alt = variants.filter(function (x) { return x.options[idx] === e.target.value; });
        alt.sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });
        if (alt[0]) {
          v = alt[0];
          fsets.forEach(function (fs, i) {
            fs.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === v.options[i]; });
          });
        }
      }
      if (!v) {
        if (btn) { btn.disabled = true; btnLabel.textContent = txtNone; }
        return;
      }
      if (idInput) idInput.value = v.id;
      priceNow.forEach(function (p) { p.textContent = money(v.price, fmt); });
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      priceOld.forEach(function (p) {
        if (onSale) { p.textContent = money(v.compare_at_price, fmt); p.hidden = false; } else { p.hidden = true; }
      });
      if (saveEl) {
        if (onSale) { saveEl.textContent = saveEl.getAttribute('data-txt') + ' ' + money(v.compare_at_price - v.price, fmt); saveEl.hidden = false; }
        else saveEl.hidden = true;
      }
      if (btn) { btn.disabled = !v.available; btnLabel.textContent = v.available ? txtAdd : txtSold; }
      if (v.media_id) {
        var ti = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') == v.media_id; });
        if (ti > -1) show(ti);
        else if (v.featured_image && main) { main.src = v.featured_image; main.removeAttribute('srcset'); }
      }
      if (root.closest('.zn-pdp') && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-zn-option] input').forEach(function (i) { i.addEventListener('change', update); });

    // Cantidad
    var qty = root.querySelector('[data-zn-qty]');
    root.querySelectorAll('[data-zn-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qty.value, 10) || 1;
        qty.value = Math.max(1, n + parseInt(b.getAttribute('data-zn-qty-btn'), 10));
      });
    });

    // Añadir al carrito → página del carrito
    var msg = root.querySelector('[data-zn-msg]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn) btn.disabled = true;
        if (msg) msg.textContent = '';
        fetch(root_url + 'cart/add.js', {
          method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { if (msg) msg.textContent = res.j.description || res.j.message || 'Error'; if (btn) btn.disabled = false; return; }
            window.location.href = root_url + 'cart';
          })
          .catch(function () { form.submit(); });
      });
    }

    // Barra fija en móvil
    var sticky = root.querySelector('[data-zn-sticky]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      });
      io.observe(btn);
      var sb = sticky.querySelector('[data-zn-sticky-btn]');
      if (sb) sb.addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  }

  // Antes / después: la pestaña sigue al dedo o al ratón (input range invisible encima)
  function initBA(scope) {
    (scope || document).querySelectorAll('[data-zn-ba]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '1');
      var r = el.querySelector('[data-zn-ba-range]');
      if (!r) return;
      function set() { el.style.setProperty('--pos', r.value + '%'); }
      r.addEventListener('input', set);
      r.addEventListener('pointerdown', function () { el.classList.add('is-dragging'); el.classList.remove('zn-ba--hint'); });
      ['pointerup', 'pointercancel', 'blur'].forEach(function (ev) { r.addEventListener(ev, function () { el.classList.remove('is-dragging'); }); });
      set();
      // Pequeño "empujón" de la pestaña la primera vez que se ve, para invitar a deslizar
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (e.isIntersecting) { el.classList.add('zn-ba--hint'); io.disconnect(); } });
        }, { threshold: 0.6 });
        io.observe(el);
      }
    });
  }

  // Cómo funciona: pasos que avanzan solos, clic en cada paso y deslizar en móvil
  function initFlow(scope) {
    (scope || document).querySelectorAll('[data-zn-flow]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '1');
      var slides = el.querySelectorAll('[data-zn-flow-slide]');
      var steps = el.querySelectorAll('[data-zn-flow-step]');
      var dots = el.querySelectorAll('[data-zn-flow-dot]');
      if (!slides.length) return;
      var auto = el.getAttribute('data-auto') === 'true' && !reduce;
      var dur = (parseFloat(el.getAttribute('data-dur')) || 5) * 1000;
      var i = 0, timer = null, visible = false, userStopped = false;

      function go(n) {
        i = (n + slides.length) % slides.length;
        [slides, steps, dots].forEach(function (list) {
          list.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
        });
        steps.forEach(function (s, k) { s.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        restart();
      }
      function restart() {
        clearTimeout(timer);
        var playing = auto && visible && !userStopped;
        el.classList.remove('is-playing');
        if (playing) {
          void el.offsetWidth; // reinicia la barra de progreso
          el.classList.add('is-playing');
          timer = setTimeout(function () { go(i + 1); }, dur);
        }
      }
      steps.forEach(function (s, k) {
        s.addEventListener('click', function () { userStopped = true; go(k); });
      });
      el.addEventListener('mouseenter', function () { if (auto) { clearTimeout(timer); el.classList.remove('is-playing'); } });
      el.addEventListener('mouseleave', function () { restart(); });

      var stage = el.querySelector('.zn-flow__stage');
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { userStopped = true; go(i + (dx < 0 ? 1 : -1)); }
        x0 = null;
      });
      stage.addEventListener('click', function () { userStopped = true; go(i + 1); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) { visible = e.isIntersecting; restart(); });
        }, { threshold: 0.35 }).observe(el);
      } else { visible = true; restart(); }
    });
  }

  function initCompras(scope) {
    (scope || document).querySelectorAll('[data-zn-buy]').forEach(initCompra);
  }

  function init() {
    initReveal();
    initCifras();
    initParallax();
    initCompras();
    initBA();
    initFlow();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initCifras(e.target); initCompras(e.target); initBA(e.target); initFlow(e.target);
  });
})();
